export default __webpack_public_path__ + "static/media/cw27.c1be76ee.jpg";